(function() {
  function init() {
    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;
    if (typeof PhotoSwipe === 'undefined') return;

    var dimensionCache = {};

    function preloadDimensions(urls, callback) {
      var pending = urls.length;
      if (pending === 0) return callback();
      urls.forEach(function(url) {
        if (dimensionCache[url]) { pending--; if (pending === 0) callback(); return; }
        var img = new Image();
        img.onload = function() {
          dimensionCache[url] = { w: this.naturalWidth, h: this.naturalHeight };
          pending--; if (pending === 0) callback();
        };
        img.onerror = function() {
          dimensionCache[url] = { w: 1200, h: 1200 };
          pending--; if (pending === 0) callback();
        };
        img.src = url;
      });
    }

    function openLightbox(clickedLink) {
      var allLinks = document.querySelectorAll('.photo-zoom-link');
      var urls = [];
      allLinks.forEach(function(l) {
        var u = l.getAttribute('data-zoom-size');
        if (u) urls.push(u);
      });
      var index = Array.prototype.indexOf.call(allLinks, clickedLink);

      preloadDimensions(urls, function() {
        var items = urls.map(function(url) {
          var dim = dimensionCache[url] || { w: 1200, h: 1200 };
          return { src: url, w: dim.w, h: dim.h };
        });
        var options = { index: index < 0 ? 0 : index, bgOpacity: 0.9, showHideOpacity: true, history: false, shareEl: false, fullscreenEl: false, zoomEl: false };
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      });
    }

    function attachHandlers() {
      var links = document.querySelectorAll('.photo-zoom-link');
      links.forEach(function(link) {
        if (link.dataset.lightboxBound) return;
        link.dataset.lightboxBound = 'true';
        var startX = 0, startY = 0, startTime = 0, moved = false;
        link.addEventListener('pointerdown', function(e) { startX = e.clientX; startY = e.clientY; startTime = Date.now(); moved = false; });
        link.addEventListener('pointermove', function(e) { if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true; });
        link.addEventListener('pointerup', function(e) {
          var deltaTime = Date.now() - startTime;
          if (!moved && deltaTime < 500) { e.preventDefault(); e.stopPropagation(); openLightbox(link); }
        });
      });
    }

    attachHandlers();
    var observer = new MutationObserver(function() { attachHandlers(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();